/**
 * brands.ts
 * Sentriqs
 *
 * Created by: Dylan Knight
 * Copyright (c) 2024 Sentriqs. All rights reserved.
 *
**/

export enum Brand {
  WORKSPACE = "mw",
  GLYPH = "glyph"
}
